import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const IoGlyph = /*#__PURE__*/createElement("g", {
  id: "io"
}, /*#__PURE__*/createElement("path", {
  d: "M64.2,17H19.8c-1.5,0-2.8,1.2-2.8,2.8v44.4c0,1.5,1.3,2.8,2.8,2.8h44.4c1.5,0,2.8-1.3,2.8-2.8V19.8 C67,18.2,65.7,17,64.2,17z M33.8,56.9L23.5,46.7l2.4-2.3l5.9,5.9c0-5.9,0-11.8,0-17.7c0-2.7,4.2-2.7,4.2,0c0,5.9,0,11.7,0,17.6 l5.9-5.7l2.4,2.3L33.8,56.9z M57.9,40l-5.9-5.9c0,5.9,0,11.8,0,17.7c0,2.7-4.2,2.7-4.2,0c0-5.9,0-11.7,0-17.6L41.9,40l-2.4-2.3 L50,27.5l10.3,10.2L57.9,40z"
}));
const Io = createSvg({
  name: 'io',
  path: IoGlyph
});

export default Io;
export { IoGlyph };
